import apiService, { ServiceType } from './api';

/**
 * Client for the AI trading-assistant endpoints (BE `/ai/*`).
 *
 * The BE proxies these to the Python finance agent, which interprets the
 * question, runs analysis skills, and answers. The assistant NEVER places
 * orders — it only analyses and suggests. Auth (JWT) is added by the shared
 * axios interceptor in `./api`.
 */

export interface AiSkill {
  name: string;
  description: string;
}

export interface AiTraceStep {
  tool: string;
  arguments: string | null;
  result: Record<string, unknown>;
}

export interface AiChatResponse {
  answer: string;
  steps: number;
  trace: AiTraceStep[];
}

export interface AiHealth {
  ok: boolean;
  llmBaseUrl: string;
  llmModel: string | null;
  skills: AiSkill[];
}

const core = () => apiService.getService(ServiceType.CORE);

export async function getAiHealth(): Promise<AiHealth> {
  const { data } = await core().get<AiHealth>('/ai/health');
  return data;
}

export async function getAiSkills(): Promise<AiSkill[]> {
  const { data } = await core().get<AiSkill[]>('/ai/skills');
  return data;
}

export async function sendAiChat(
  message: string,
  maxSteps?: number,
): Promise<AiChatResponse> {
  const { data } = await core().post<AiChatResponse>('/ai/chat', {
    message,
    ...(maxSteps != null ? { maxSteps } : {}),
  });
  return data;
}
